import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationService } from '@seahorse/common';

@Component({
  selector: 'sh-copy-content-wrapper',
  templateUrl: 'copy-content-wrapper.component.html',
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class CopyContentWrapperComponent {
  @Input() show = false;

  get content(): string {
    return this._el.nativeElement.textContent;
  }

  get displayCopyButton() {
    return this.show && !!this.content?.trim();
  }

  constructor(
    private notificationService: NotificationService,
    private _el: ElementRef
  ) {}

  async copy() {
    if (!this.content || this.content.toString().length === 0) {
      return;
    }

    await navigator.clipboard.writeText(this.content);
    this.notificationService.showInfo('shared.terms.copied');
  }
}
